import React from "react";

export const Logo = ({ size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="madreterra-logo"
      aria-label="MADRETERRA radio logo"
    >
      {/* outer ring */}
      <circle cx="32" cy="32" r="30" stroke="#d4a05b" strokeWidth="1.5" />
      {/* sun rays */}
      {Array.from({ length: 12 }).map((_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        const x1 = 32 + Math.cos(angle) * 24;
        const y1 = 32 + Math.sin(angle) * 24;
        const x2 = 32 + Math.cos(angle) * 28;
        const y2 = 32 + Math.sin(angle) * 28;
        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="#d4a05b"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        );
      })}
      {/* central tau cross + dove arc */}
      <path
        d="M22 24 H42"
        stroke="#f0bd6e"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M32 24 V46"
        stroke="#f0bd6e"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      {/* earth curve */}
      <path
        d="M14 44 Q32 56 50 44"
        stroke="#b85530"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

export default Logo;
